import { RadioGroup } from 'components/RadioGroup/RadioGroup'
import { styled } from 'stitches.config'

export const Option = styled(RadioGroup.Option, {
  flexWrap: 'nowrap',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '$1',
  width: '140px',
  height: '54px',
  backgroundColor: '$accent-white',
  border: '1px solid $secondary-600',
  borderRadius: '$3',
  transition: 'all 0.1s ease-in',
  color: '$secondary-700',
  flex: '1 1 0px',
  '& label': {
    fontWeight: '$regular',
  },

  '&:hover': {
    cursor: 'pointer',
    boxShadow: '2px 2px 6px $colors$tertiary-100',
  },

  '&[aria-checked=true]': {
    color: '$secondary-800',
    border: '1px solid $secondary-800',
    backgroundColor: '$tertiary-100',
    boxShadow: '2px 2px 6px $colors$tertiary-100',
  },

  '@bp1': {
    width: '160px',
  },
  '@bp2': {
    minWidth: '226px',
    height: '54px',
  },
})
